import * as React from 'react'
import dynamic from 'next/dynamic'

import { i18n } from '@thg-commerce/enterprise-core'
import { spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { useTheme } from '@thg-commerce/gravity-elements/theme'

import { Content, LeftContent } from '../styles'

const SvgIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/SvgIcon'),
)

const RingCentralIconWrapper = styled.div`
  display: flex;
  margin-top: ${spacing(2)};
`

const RingCentralContainer = styled.div<{ alternateText?: boolean }>`
  ${(props) => Text('bodyText', props.alternateText ? 'alternate' : 'default')}
  display: flex;
  align-items: flex-start;
  position: relative;
  cursor: pointer;
`

const RingCentralTextHeading = styled.div<{ alternateText?: boolean }>`
  ${(props) => Text('bodyText', props.alternateText ? 'alternate' : 'default')}
  font-weight: 900;
  display: block;
`

const RingCentralTextBody = styled.p<{ alternateText?: boolean }>`
  ${(props) => Text('bodyText', props.alternateText ? 'alternate' : 'default')}
`

const RingCentralContentWrapper = styled.div`
  display: flex;
  align-items: left;
`

const RingCentralTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${(props) => props.theme.colors.palette.greys[300]};
`

export interface RingCentralContentProps {
  alternateText?: boolean
  outline?: boolean
  helpTitle?: string
  helpText?: string
}

export const RingCentralContent = (props: RingCentralContentProps) => {
  const {
    icons: { chatOutline },
  } = useTheme()

  const i18nText = {
    ringCentral: {
      helptitle: i18n('myaccount.ringcentral.helptitle'),
      helptext: i18n('myaccount.ringcentral.helptext'),
    },
  }

  const triggerRingCentralChat = () => {
    try {
      if (typeof window === 'undefined' || !(window as any).Dimelo) {
        console.warn(
          'Window object is not available or Ring Central is not initialized yet.',
        )
        return
      }

      const clickChat = () => {
        const chatElement = document.querySelector<HTMLElement>(
          '.dimelo_chat_item_action, .dimelo-chat-bubble',
        )
        chatElement?.click()
        return chatElement
      }

      if (!clickChat()) {
        let clicked = false
        const observer = new MutationObserver(() => {
          if (!clicked && clickChat()) {
            clicked = true
            observer.disconnect()
          }
        })

        observer.observe(document.body, { childList: true, subtree: true })
        setTimeout(() => observer.disconnect(), 10000)
      }
    } catch (error) {
      console.error('Error triggering Ring Central Chat:', error)
    }
  }

  return (
    <RingCentralContainer
      data-testid="live-chat"
      alternateText={props.alternateText}
      onClick={triggerRingCentralChat}
    >
      <LeftContent>
        <RingCentralIconWrapper>
          <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            viewBox={chatOutline?.viewBox}
            width={chatOutline?.width}
            height={chatOutline?.height}
          >
            <path d={chatOutline?.svgPath} fillRule="evenodd" />
          </SvgIcon>
        </RingCentralIconWrapper>
      </LeftContent>
      <Content>
        <RingCentralContentWrapper>
          <RingCentralTextContainer>
            <RingCentralTextHeading>
              {i18nText.ringCentral.helptitle}
            </RingCentralTextHeading>
            <RingCentralTextBody>
              {i18nText.ringCentral.helptext}
            </RingCentralTextBody>
          </RingCentralTextContainer>
        </RingCentralContentWrapper>
      </Content>
    </RingCentralContainer>
  )
}
